import type { Track } from "@/types/types";
import { TrackRow } from "./TrackRow";

export function TrackList({ tracks }: { tracks: Track[] }) {
  return (
    <div className="tracklist">
      <div className="tracklist-header" aria-hidden="true">
        <span>#</span>
        <span />
        <span>Titre</span>
        <span>Durée</span>
        <span />
      </div>
      {tracks.map((t, i) => <TrackRow key={t.id} track={t} index={i} queue={tracks} />)}
    </div>
  );
}
